import LoaderImage from "../images/ohhto-loading.gif";

const CustomLoaderComponent = () => {
    return (
        <div className="absolute z-50 left-0 top-0 w-full h-full  flex items-center justify-center">
            <img src={LoaderImage} className="w-24 h-24" />
        </div>
    )
}
export default CustomLoaderComponent